import * as yup from "yup";
import { Formik } from "formik";
import { useEffect, useRef, useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "../../../../components/ui/button";
import Common from "../../../../helper/common";
import {
  FormikInput,
  FormikSearchSelect,
  FormikTextArea,
} from "../../../../components/formik-components";
import {
  respEnum,
  IntMax,
  IntMinLevel,
} from "../../../../constants/appConstant";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../../components/ui/dialog";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

const FormikInitialValues = {};

const formikValidation = yup.object({
  expenseHeadId: yup.number().required("Expense Account is required"),
  name: yup.string().trim().min(2).max(50).required("Expense is required"),
  amount: yup.number().min(1).max(IntMax).required("Amount Required"),
  desc: yup.string().trim().min(5).max(200),
  //clubaccountId: yup.number().required("Club Account is required"),
});

const AddExpense = ({ id, onClose, open, setOpen }) => {
  const formikRef = useRef();
  const dialogRef = useRef();
  const [accountList, setAccountList] = useState([]);
  //const [clubaccountId, setClubaccountId] = useState(null);
  //const [paymentTypeList, setPaymentTypeList] = useState([]);
  const navigate = useNavigate();
  const [isFormikInitialized, setIsFormikInitialized] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      getExpenseAccount();
      //getClubPaymentTypes();
    };
    fetchData();
  }, []);

  useEffect(() => {
    setIsFormikInitialized(open);
  }, [open]);

  useEffect(() => {
    if (id) {
      getDataInfo();
    }
  }, [id]);

  //const getClubPaymentTypes = async () => {
  //    const response = await Common.ApiService.getInstance().request(
  //        "GetClubPaymentTypes?isForReport=true"
  //    );

  //    if (response?.status == respEnum.Success) {
  //        setPaymentTypeList(response?.data ?? []);
  //    }
  //};

  const getExpenseAccount = async () => {
    return new Promise(async (res) => {
      const response = await Common.ApiService.getInstance().request(
        "GetExpenseAccounts"
      );
      const data = [
        { id: null, name: "Select Expense Type" },
        ...(response?.data ?? []),
      ];

      setAccountList(data);
    });
  };

  const onSubmitData = async (d, action) => {
    let data = {
      ...d,
      id,
    };
    let response = await Common.ApiService.getInstance().request(
      "AddUpdateExpense",
      data,
      "POST"
    );
    action.setSubmitting(false);
    if (response.status === respEnum.Success) {
      onClose(response.data);
      setOpen(false);
      if (!onClose) {
        navigate("/app/Expenses", { replace: true });
      }
    }
  };

  const getDataInfo = async () => {
    debugger;
    let response = await Common.ApiService.getInstance().request(
      `GetExpenseDetails?id=${id}`
    );
    if (response.status === respEnum.Success && response.data.length > 0) {
      formikRef.current.setValues(response.data[0]);
    }
  };

  return (
    <div>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogTrigger asChild>
          <Button
            size="sm"
            variant="primary"
            className="flex items-center gap-2"
          >
            <Icon icon="heroicons:plus-20-solid" className="h-4 w-4" />
            Add
          </Button>
        </DialogTrigger>
        <DialogContent ref={dialogRef}>
          <DialogHeader>
            <DialogTitle className="text-base font-medium ">
              {!id ? "Add" : "Update"} Expense
            </DialogTitle>
          </DialogHeader>

          <div className="text-sm text-default-500  space-y-2">
            <Formik
              innerRef={formikRef}
              onSubmit={onSubmitData}
              initialValues={FormikInitialValues}
              validationSchema={formikValidation}
              validateOnChange={false}
              validateOnBlur={false}
            >
              {(formikProps) => (
                <div className="md:grid md:grid-cols-1 gap-6 mt-6 space-y-6 md:space-y-0">
                  <div className="col-span-1">
                    <div className="md:grid md:grid-cols-1  gap-6 mt-6 space-y-6 md:space-y-0">
                      <div className="flex flex-col gap-3">
                        <FormikSearchSelect
                          formikProps={formikProps}
                          name={"expenseHeadId"}
                          placeholder={"Select Account Type"}
                          label={"Expense Accounts"}
                          data={accountList}
                        />
                      </div>
                      <div className="flex flex-col gap-2">
                        <FormikInput
                          formikProps={formikProps}
                          name={"name"}
                          label={"Expense"}
                          placeholder={"Expense Name"}
                          maxLength="50"
                        />
                      </div>

                      {/*<FormikSearchSectionSelect*/}
                      {/*    formikProps={formikProps}*/}
                      {/*    name={"clubaccountId"}*/}
                      {/*    label={"Payment Account"}*/}
                      {/*    data={paymentTypeList}*/}
                      {/*/>*/}

                      <div className="flex flex-col gap-3">
                        <FormikInput
                          formikProps={formikProps}
                          name={"amount"}
                          placeholder={"Amount"}
                          label={"Amount"}
                          type={"number"}
                          max={IntMax}
                          min={IntMinLevel}
                          onChange={(value) => {
                            if (value < IntMinLevel && value != "") {
                              formikProps.setFieldValue("amount", IntMinLevel);
                            } else if (value >= IntMax) {
                              toast.error(
                                `amount cannot be greater than ${IntMax}`
                              );
                              formikProps.setFieldValue("amount", "");
                            } else {
                              formikProps.setFieldValue("amount", value);
                            }
                          }}
                        />
                      </div>

                      <div className="flex flex-col gap-2">
                        <FormikTextArea
                          formikProps={formikProps}
                          name={"desc"}
                          placeholder={"Type..."}
                          type={"textarea"}
                          label={"Description"}
                          maxLength={200}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </Formik>
          </div>
          <DialogFooter className="mt-8 gap-2">
            <DialogClose asChild>
              <Button type="button" variant="outline">
                Close
              </Button>
            </DialogClose>

            {isFormikInitialized && formikRef.current && (
              <Button
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  formikRef.current?.handleSubmit();
                }}
              >
                {formikRef.current.isSubmitting
                  ? "Saving..."
                  : !id
                  ? "Add"
                  : "Update"}
              </Button>
            )}
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddExpense;
